/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/schedule" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdScheduleCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdScheduleProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdSchedule = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdScheduleCacheKeys,
  (
    props: PutDecisioningStudioAgentsAppGroupIdDsaIdScheduleProps
  ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult> => {
    const { appGroupId, dsaId, frequencies, days_of_week, signal } = props;
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/timing/schedule`,
      "PUT",
      {
        frequencies,
        days_of_week,
      },
      signal ? { signal } : undefined,
      { propagateFetchRequestError: false }
    );
  }
);
